import HomeContainer from './HomeContainer';

const HomeView = () => {
  return <HomeContainer />;
};

export default HomeView;
